import store from "./../../../store";
import accountService from "./../../../services/account";
import teamMemberService from "./../../../services/team_member";
import Vue from "vue";
import moment from "moment";
import mixin from "../../../mixins/mixin";
import stripeAccountsService from "../../../services/stripe_accounts";
import theKeysService from "../../../services/the_keys";
import rentalService from "../../../services/rental";
import airbnb from "../../../services/airbnb";
import eventLogger from "../../../services/event-logger";

let clipboard = "";

export default {
  data() {
    return {
      airbnbOauthUrl: null,
      selectedOption: "owner_account",
      email_another_account_airbnb: "",
      redirectlink: "",
      disableConnectAirbnbBtn: false,
      currentAirbnbXmId: "",
      currentAibnbAccountId: "",
      callback_url: "account/settings/platforms",
      code: "",
      token: "",
      users: {
        full_name: store.state.account.full_name,
        email: store.state.account.email,
        beds24ApiKey: store.state.account.beds24ApiKey,
        address: store.state.account.address,
        avatar: store.state.account.avatar,
        avatarPath: store.state.account.avatarPath,
        lang: store.state.account.lang,
        setting: {
          use_own_email_address: "no",
        },
        currency: store.state.account.currency,
        website_settings: {
          google_pixel_head: "",
          google_pixel_body: "",
          google_pixel_thank_you: "",
          custom_style: "",
        },
        engine_link: "",
      },
      superCheckin: {
        id: null,
        superCheckinUsername: null,
        superCheckinPassword: null,
        loading: false,
      },
      image: {},
      countries: {},
      currencies: {},
      error: null,
      success: false,
      loading: false,
      activeTab: "informations",
      interval: "",
      events: [],
      stripeClientId: process.env.STRIPE_CLIENT_ID,
      stripe_accounts: [],
      stripe_name: "",
      index_stripe: {},
      update_stripe: {},
      delete_stripe: {},
      accountHavePaymetns: false,
      members: [],
      btnDisabled: false,
      btnSyncLocksDisabled: false,
      key: {
        username: "",
        password: "",
      },
      newAirbnbAccount: {},
      airbnbAccounts: [],
      listings: [],
      rentals: [],
      options: [
        { label: "Créer un nouveau hébergement", value: "create_new" },
        { label: "Ne rien faire", value: "" },
      ],
      activeStep: 1,
      abAccount: {
        error: null,
        errorMsg: "",
        loading: false,
        verified: false,
        airbnbPassword: "",
        airbnbUsername: "",
        afterAirlock: false,
        allRentalsSelected: false,
        mfaOptions: [],
        tempId: null,
      },
      airbnbLastCheckAirlock: null,
      airbnbAccount: {},
      editAirbnbAccountPwd: {
        oldPassword: null,
        password: null,
        password_confirmation: null,
      },
      airbnbActiveStep: 1,
      airbnbActiveLoading: false,
      airbnbRentals: [],
      user: {
        is_team_member: "",
        rights: {},
        parent_emails: [],
      },
      limit: 100,
      currentPage: 0,
      lastPage: "",
      currentPassword: "",
      newPassword: "",
      repeatNewPassword: "",
      userConfirmedPlatforms: [],
      airlockId: 0,
      randomDeviceId: null,
      verificationFrictionData: [],
      verificationFrictionType: "phone_verification_via_text",
      verificationFrictionMethodData: {},
      frictionDataAll: [],
      airbnbVerificationCode: "",
      airbnbVerificationData: {},
      airbnbToken: "",
      airbnbUserId: "",
      allProperties: [],
      isAllRentalsChecked: false,
      smallLoading: false,
      userAvatar: [],
      newAirbnbRentals: [],
      isReconnectingAccount: false,
      changePwdStep: 0,
      airlockData: {
        airlock: "",
        friction: "",
      },
      airbnbUserIsV2: false,
      phoneNumberId: "",
      airLockUID: null,
      frictionDataReceived: false,
      isIgloohomeConnected: false,
      isIgloohomeV2Connected: false,
      igloohomeApiKey: null,
      isNukiConnected: false,
      nukiApiKey: null,
      isTheKeysConnected: false,
      theKeys: {
        username: null,
        password: null,
      },
      logs: [],
    };
  },
  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    VLoading: require("components/loading/loading.vue"),
    VStripeConnect: require("components/stripe-connect/connect.vue"),
    VTemplates: require("pages/message-templates/index/index.vue"),
    VRules: require("pages/payment-rules/index/index.vue"),
    VCard: require("../credit-card/index/index.vue"),
    VSmsInfo: require("../sms-info/index/index.vue"),
    PHPUnserialize: require("php-unserialize/php-unserialize"),
    VConfigureIgloohome: require("./ConfigureIgloohome"),
    VConfigureIgloohomeV2: require("./ConfigureIgloohomeV2"),
    VConfigureNukiLock: require("./ConfigureNukiLock"),
    VImportNewAirbnbRentals: require("./modals/ImportNewAirbnbRentals"),
    VVrboDefaultConfigurationTab: require("./VrboDefaultConfigurationTab/VrboDefaultConfigurationTab.vue"),
    VVrboUserConnectionModal: require("./modals/VrboUserConnectionModal"),
    VGoogleUserConnectionModal: require("./modals/GoogleUserConnectionModal"),
    VInputPassword: require("components/password-input/VueInputPassword.vue"),
    website: require("./Website"),
  },

  mixins: [mixin],

  methods: {
    resetAirbnbLogin() {
      this.activeStep = 1;
      this.airbnbActiveStep = 1;
      this.airbnbActiveLoading = false;
      this.randomDeviceId = null;
      this.isReconnectingAccount = false;
      this.abAccount = {
        error: null,
        errorMsg: "",
        loading: false,
        verified: false,
        airbnbPassword: "",
        airbnbUsername: "",
        afterAirlock: false,
        allRentalsSelected: false,
        mfaOptions: [],
        tempId: null,
      };
      this.verificationFrictionData = [];
    },

    checkIsInProgress() {
      const vm = this;
      accountService.checkProgress(vm);
    },

    update(user) {
      const {
        stripe_id,
        stripe_card_id,
        stripe_token,
        card_last_four,
        card_brand,
        ...userData
      } = user;

      this.error = this.success = false;
      this.loading = true;

      if (
        $("#user-avatar-container .dropify-errors-container ul")[0]
          .innerText === ""
      ) {
        this.image = this.userAvatar[0];
      }

      const img = this.image;
      const image = { image: img };

      const formData = new FormData();
      formData.append("image", img);
      formData.append("folder", "users");

      if (img && img.name) {
        accountService.uploadPhoto(this, formData, userData);
      } else {
        this.edit(userData);
        this.loading = false;
      }
    },

    saveVrboDefaultConfigurationTabData() {
      this.$refs.vrboDefaultConfigurationTab.saveData();
    },

    getProperties() {
      const vm = this;
      vm.loading = true;
      rentalService.getProperties(vm);
    },

    importData() {
      const vm = this;
      rentalService.syncData(vm, vm.allProperties);
    },

    getAllRentals() {
      rentalService.getRentalsList(this).then((response) => {
        // const rentalsWithNullAirbnbAccountId = this.rentals.filter(rental => rental.airbnb_account_id === null);
        this.rentals.forEach((rental) => {
          this.options.push({ label: rental.name, value: rental.id });
        });
      });
    },

    filterByRentals(id = null) {
      const vm = this;
      if (id === "all") {
        vm.allProperties.map((property) => {
          property.checked = vm.isAllRentalsChecked;
          property.roomTypes.map((room) => {
            room.checked = vm.isAllRentalsChecked;
          });
        });
      } else if (id != null) {
        let bigState = false;
        vm.allProperties.map((property) => {
          if (property.checked == false) {
            bigState = true;
          }

          if (property.propId === id) {
            const state = property.checked;
            property.roomTypes.map((room) => {
              room.checked = state;
            });
          }
        });
        if (bigState != true) {
          vm.isAllRentalsChecked = true;
        } else {
          vm.isAllRentalsChecked = false;
        }
        vm.$forceUpdate();
      }
    },

    filterByRooms(propId, roomId) {
      const vm = this;
      if (propId != null && roomId != null) {
        vm.allProperties.map((property) => {
          if (property.propId === propId) {
            property.roomTypes.map((room) => {
              if (room.roomId == roomId) {
                if (room.checked == false) {
                  property.checked = false;
                  vm.isAllRentalsChecked = false;
                  vm.$forceUpdate();
                } else if (room.checked == true) {
                  let state = false;
                  property.roomTypes.map((r) => {
                    if (r.checked == false) {
                      state = true;
                    }
                  });

                  if (state != true) {
                    property.checked = true;
                    let bigState = false;
                    vm.allProperties.map((property) => {
                      if (property.checked == false) {
                        bigState = true;
                      }
                    });
                    if (bigState == false) {
                      vm.isAllRentalsChecked = true;
                    }
                  }
                  vm.$forceUpdate();
                }
              }
            });
          }
        });
      }
    },

    async edit(user) {
      user.lang = Vue.config.lang;
      await accountService.update(this, user, true);
    },

    onFileChange(e) {
      const vm = this;
      vm.userAvatar = e.target.files || e.dataTransfer.files;
      if (!vm.userAvatar.length) {
      }
    },

    deleteUserAvatar(user) {
      this.loading = true;
      accountService.deleteAvatar(this, user);
    },

    async fetch_account() {
      const vm = this;
      await accountService.fetchAccount(vm);
    },

    async fetch_events() {
      const vm = this;
      await accountService.fetchEvents(vm, vm.limit, vm.currentPage);
    },

    async change_tab(tab) {
      const vm = this;
      const tabs = [
        "credit_card",
        "event-logger",
        "informations",
        "message_templates",
        "payment_rules",
        "platforms",
        "services",
        "sms_info",
        "vrbo-default-configuration-tab",
        "website",
      ];
      if (tabs.includes(tab)) {
        vm.activeTab = tab;
      }

      switch (tab) {
        case "event-logger":
          await eventLogger.get(this);
          break;
      }

      Vue.router.push({
        name: "account.settings.tab",
        params: { tab: vm.activeTab },
        query: this.$route.query,
      });
    },

    replayPayment(event) {
      const vm = this;
      vm.loading = true;
      accountService.replayPayment(vm, event);
    },

    async sync_devices(settings) {
      const vm = this;
      vm.btnDisabled = true;

      const netatmo = {
        netatmo_access_token: settings.netatmo_access_token,
        netatmo_refresh_token: settings.netatmo_refresh_token,
        netatmo_client_id: settings.netatmo_client_id,
        netatmo_client_secret: settings.netatmo_client_secret,
      };
      await accountService.syncDevices(vm, netatmo);
      mixpanel.track("web.settings.services.netatmo.sync");
    },

    async sync_locks() {
      const data = {};
      data.username = this.theKeys.username;
      data.password = this.theKeys.password;
      this.btnSyncLocksDisabled = true;
      await theKeysService.sync(this, data);
      await accountService.fetchAccount(this);
      mixpanel.track("web.settings.services.thekeys.sync");
    },

    async deleteTheKeys() {
      await theKeysService.deleteTheKeys(this);
      await accountService.fetchAccount(this);
    },

    async deleteIgloohome() {
      await accountService.deleteIgloohome(this);
      await accountService.fetchAccount(this);
    },

    async deleteIgloohomeV2() {
      await accountService.deleteIgloohomeV2(this);
      await accountService.fetchAccount(this);
    },

    async deleteNukiLock() {
      await accountService.deleteNukiLock(this);
      await accountService.fetchAccount(this);
    },

    openStripeEditModal(account = {}) {
      this.update_stripe = { ...account };
      this.openModal("#addStripeAccount");
    },

    getStripeAccounts() {
      stripeAccountsService.get(this);
    },

    getTheamMembers() {
      teamMemberService.get(this);
    },

    deleteStripeAccount(index) {
      const vm = this;
      const stripe_account = vm.stripe_accounts[index];
      const data = {
        id: stripe_account.id,
      };
      if (vm.accountHavePaymetns) {
        data.confirmed = true;
      }
      stripeAccountsService.deleteStripeAccount(this, data, index);
    },

    openStripeAccountDeleteModal(modalName, index) {
      this.openModal(modalName);
      this.index_stripe = index;
    },

    confirmDeleteStripeAccount(data, index) {
      $(".cancel").removeClass("disabled");
      swal(
        {
          title: "",
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader">
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75">
<circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t(
            "account.settings.stripe_account_delete"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.modals.yes_delete_it"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          data.confirmed = true;
          stripeAccountsService.deleteStripeAccount(this, data, index);
        }
      );
    },

    updateStripeAccount(stripe_account) {
      stripeAccountsService.update(this, stripe_account);
    },

    closeAddStripeAccount() {
      const vm = this;
      vm.closeModal("#addStripeAccount");
      vm.stripe_name = "";
    },

    deleteTeamMember(id) {
      const vm = this;
      swal(
        {
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this user</div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          accountService.deleteTeamMembers(vm, id);
        }
      );
    },

    setupTeamMember() {
      Vue.router.push({
        name: "new.user.create",
      });
    },

    changeUserStatus(user) {
      const vm = this;
      swal(
        {
          title: "Are you sure?",
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>Would you like to ${
            user.active ? "deactivate" : "activate"
          } this user ?</div>`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Not now",
          confirmButtonClass: "btn-success",
          confirmButtonText: "Yes, do it!",
          closeOnConfirm: false,
          html: true,
        },
        (isConfirm) => {
          if (isConfirm) {
            $(".pulseWarning").hide();
            $(".cancel").addClass("disabled");
            $(".confirm").addClass("disabled");
            $("#loading1").show();
            user.active = !user.active;
            user.change_password = 0;
            accountService.updateTeamMembers(vm, user);
          }
        }
      );
    },

    getAirbnbAccounts() {
      const vm = this;
      accountService.getAirbnbAccounts(vm);
    },

    showAddWizard() {
      const vm = this;
      this.airbnbActiveStep = 1;

      vm.airbnbActiveLoading = false;
      vm.abAccount.error = null;
      vm.abAccount.errorMsg = "";
      vm.abAccount.loading = false;
      vm.abAccount.mfaOptions = [];
      vm.openModal(".add-new-airbnb-account");
    },

    showAddNewAccount(airbnbActiveStep = 1) {
      const vm = this;
      this.airbnbActiveStep = airbnbActiveStep;
      this.abAccount = {
        id: null,
        error: null,
        errorMsg: "",
        loading: false,
        verified: false,
        airbnbPassword: "",
        airbnbUsername: "",
        afterAirlock: false,
        allRentalsSelected: false,
        mfaOptions: [],
        tempId: null,
      };
      this.selectedOption = "owner_account";
      this.email_another_account_airbnb = "";
      vm.openModal(".add-new-airbnb-account_template");
    },

    openVrboUserConnectionModal() {
      this.openModal("#vrbo-user-connection-modal");
    },

    openGoogleUserConnectionModal() {
      this.openModal("#google-user-connection-modal");
    },

    dismiss() {
      this.resetAirbnbLogin();
      this.closeModal(".add-new-airbnb-account");
    },

    dismissModal() {
      this.airbnbActiveLoading = false;
      this.closeModal(".add-new-airbnb-account_template");
    },

    dismissMod() {
      this.resetAirbnbLogin();
      this.closeModal(".add-new-airbnb-account");
    },

    next(activeStep, airlockId = null, response = null, frictionData = null) {
      if (activeStep == 1) {
        airbnb.connect(this);
      } else if (activeStep == 2) {
        this.activeStep = 2;
        this.airlockId = airlockId;
      } else if (activeStep == 3) {
        this.activeStep = 3;
        this.airlockId = airlockId;
        if (response) {
          this.ownerVerification(response);
        }
      } else if (activeStep == 0) {
        this.activeStep = 0;
        if (response) {
          this.ownerVerificationV2(response);
        }
      } else if (activeStep == 4) {
        this.activeStep = 4;
      } else if (activeStep == 5) {
        this.activeStep = 5;
        this.smallLoading = true;
        rentalService.getAccountListings(this, this.airbnbUserId);
        accountService.getAirbnbAccounts(this);
      } else if (activeStep == 6) {
        this.activeStep = 6;
      } else if (activeStep == 99) {
        // Airlock validation
        const waitForValidation = setInterval((_) => {
          accountService.verifyAirlockValidation(
            this,
            waitForValidation,
            this.abAccount.airbnbUsername
          );
        }, 10000);
      }
    },

    ownerVerification($response) {
      const frictionData = $response.client_error_info.airlock.friction_data;
      this.frictionDataAll = frictionData;
      this.airbnbVerificationData = {
        userId: $response.client_error_info.airlock.user_id,
        id: $response.client_error_info.airlock.id,
      };
      for (const key in frictionData) {
        if (frictionData.hasOwnProperty(key) && key < 2) {
          if (
            frictionData[key] &&
            frictionData[key].data &&
            frictionData[key].data.phone_numbers &&
            frictionData[key].data.phone_numbers[0]
          ) {
            const phoneNumber = frictionData[key].data.phone_numbers[0];
            const phoneNumberObject = {
              text: `Confirm Your phone number ${phoneNumber.obfuscated} via ${
                frictionData[key].name === "phone_verification_via_text"
                  ? "text message"
                  : "a phone call"
              }`,
              name: frictionData[key].name,
              id: `message${phoneNumber.id}`,
              method: phoneNumber.verification_method,
            };
            this.verificationFrictionData = [
              ...this.verificationFrictionData,
              phoneNumberObject,
            ];
          }
        } else if (activeStep == 0) {
          this.activeStep = 0;
          if (response) {
            this.ownerVerificationV2(response);
          }
        } else if (activeStep == 4) {
          this.activeStep = 4;
        } else if (activeStep == 5) {
          this.activeStep = 5;
          this.smallLoading = true;
          rentalService.getAccountListings(this, this.airbnbUserId);
          accountService.getAirbnbAccounts(this);
        } else if (activeStep == 6) {
          this.activeStep = 6;
        } else if (activeStep == 99) {
          // Airlock validation
          const waitForValidation = setInterval((_) => {
            accountService.verifyAirlockValidation(
              this,
              waitForValidation,
              this.abAccount.airbnbUsername
            );
          }, 10000);
        }
      }
      if (
        frictionData[2] &&
        frictionData[2].data &&
        frictionData[2].data.obfuscated_email_address
      ) {
        const emailObject = {
          text: `Confirm Your email ${frictionData[2].data.obfuscated_email_address}`,
          name: frictionData[2].name,
          id: `email${frictionData[2].data.delivery_methods[0].id}`,
          method: 2,
        };
        this.verificationFrictionData = [
          ...this.verificationFrictionData,
          emailObject,
        ];
      }
    },

    verifyAccount(airlockId, pwdChanged = false) {
      window.open(
        `https://www.airbnb.com/airlock?al_id=${airlockId}`,
        "_blank"
      );
      if (pwdChanged) {
        this.changePwdStep = 0;
      } else {
        this.activeStep = 1;
      }
    },

    async verifyAirbnbAccountViaPhoneOrEmail($changedPwd = false) {
      this.smallLoading = true;
      switch (this.verificationFrictionType) {
        case "phone_verification_via_text": {
          if (this.airbnbUserIsV2) {
            const { airLockUID, phoneNumberId, code } = this;
            this.airbnbVerificationData = {
              airlockId: airLockUID,
              code,
              phoneNumberId,
              airbnbUserIsV2: true,
            };
          } else {
            this.verificationFrictionMethodData = this.frictionDataAll[0];
          }
          break;
        }
        case "phone_verification_via_call": {
          this.verificationFrictionMethodData = this.frictionDataAll[1];
          break;
        }
        case "email_code_verification": {
          this.verificationFrictionMethodData = this.frictionDataAll[2];
          break;
        }
        default: {
          this.verificationFrictionMethodData = false;
          break;
        }
      }

      if (this.verificationFrictionMethodData) {
        this.airbnbVerificationData.airlockId = this.airlockId;
        await accountService.verifyAirbnbAccountViaPhoneOrEmail(
          this,
          this.verificationFrictionMethodData,
          this.airbnbVerificationData,
          this.randomDeviceId,
          false,
          $changedPwd
        );
      }
    },
    ownerVerificationV2($response) {
      const frictionData =
        $response.client_error_info.airlockV2.frictionVersions;
      this.frictionDataAll = frictionData;
      this.airbnbVerificationData = {
        userId: this.airbnbUserId,
        id: $response.client_error_info.airlockV2.id,
      };
      for (const method of frictionData) {
        if (
          method.friction === "PHONE_VERIFICATION_VIA_TEXT" ||
          method.friction === "PHONE_VERIFICATION_VIA_CALL"
        ) {
          const phoneNumberObject = {
            text: `Confirm via ${
              method.friction === "PHONE_VERIFICATION_VIA_TEXT"
                ? "SMS"
                : "phone call"
            }`,
            name: method.friction,
            id: null,
            method: null,
          };
          this.verificationFrictionData = [
            ...this.verificationFrictionData,
            phoneNumberObject,
          ];
        } else if (method.friction === "EMAIL_CODE_VERIFICATION") {
          const emailObject = {
            text: "Confirm via email",
            name: method.friction,
            id: null,
            method: null,
          };
          this.verificationFrictionData = [
            ...this.verificationFrictionData,
            emailObject,
          ];
        }
      }
    },
    async checkAirBnbVerificationCode(pwdChanged = false) {
      this.smallLoading = true;
      if (this.airbnbUserIsV2) {
        const {
          airLockUID,
          phoneNumberId,
          airbnbVerificationCode: code,
        } = this;
        this.airbnbVerificationData = {
          airlockId: airLockUID,
          code,
          phoneNumberId,
          airbnbUserIsV2: true,
        };
        await accountService.checkAirbnbVerificationCode(
          this,
          { name: this.verificationFrictionType },
          this.airbnbVerificationData,
          this.randomDeviceId,
          this.airbnbVerificationCode,
          false,
          pwdChanged
        );
      } else if (
        this.verificationFrictionMethodData &&
        this.airbnbVerificationData
      ) {
        await accountService.checkAirbnbVerificationCode(
          this,
          this.verificationFrictionMethodData,
          this.airbnbVerificationData,
          this.randomDeviceId,
          this.airbnbVerificationCode,
          false,
          pwdChanged
        );
      }
    },

    async changePassword() {
      const vm = this;
      if (vm.newPassword != vm.repeatNewPassword) {
        toastr.error("Passwords do not match");
        return;
      } else if (vm.newPassword.length < 8) {
        toastr.error("Password must be at least 8 characters");
        return;
      }
      const data = {
        oldPassword: vm.currentPassword,
        newPassword: vm.newPassword,
      };
      await accountService.changePassword(vm, data);
    },

    async getFrictionVew() {
      this.smallLoading = true;
      this.airlockData.friction = this.verificationFrictionType.toUpperCase();
      await accountService.getFrictionView(this);
    },
    async getFrictionVew() {
      this.smallLoading = true;
      this.airlockData.friction = this.verificationFrictionType.toUpperCase();
      await accountService.getFrictionView(this);
    },
    deleteAirbnbAccount(airbnbAccountId) {
      const vm = this;
      swal(
        {
          title: this.$t(
            "account.settings.user_platforms_section.delete_airbnb_account_title"
          ),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t(
            "account.settings.user_platforms_section.delete_airbnb_account_desc"
          )} ${airbnbAccountId} ?</div>`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: this.$t("button.cancel"),
          confirmButtonClass: "btn-success",
          confirmButtonText: this.$t("swal_popup.confirm_delete"),
          closeOnConfirm: true,
          html: true,
        },
        async function (isConfirm) {
          if (isConfirm) {
            await accountService.deleteAirbnbAccount(vm, airbnbAccountId);
          } else {
            swal("Success!", this.$t("account.update_success"), "success");
          }
        }
      );
    },

    reconnectAirbnbAccount(accountId) {
      this.isReconnectingAccount = true;
      this.airbnbActiveStep = 1;
      this.airbnbActiveLoading = false;
      this.abAccount = {
        ...this.abAccount,
        airbnbUsername: this.abAccount.username,
        airbnbPassword: "",
        accountId: this.abAccount.id,
        afterAirlock: false,
        errorMsg: "",
        mfaOptions: [],
        tempId: null,
      };

      this.openModal(".add-new-airbnb-account");
      const abAccount = this.airbnbAccounts.find(
        (account) => account.id == accountId
      );
    },

    reconnectAirbnbAccountWithAirbnbXml(accountId) {
      const abAccount = this.airbnbAccounts.find(
        (account) => account.id == accountId
      );
      const vm = this;
      this.airbnbActiveStep = 1;
      this.selectedOption = "owner_account";
      this.email_another_account_airbnb = "";
      this.abAccount = {
        ...this.abAccount,
        id: abAccount.id,
        airbnbUsername: abAccount.username,
        airbnbPassword: "",
        accountId: abAccount.id,
        afterAirlock: false,
        errorMsg: "",
        mfaOptions: [],
        tempId: null,
      };

      vm.openModal(".add-new-airbnb-account_template");
    },

    async getAccountRights() {
      const vm = this;
      await accountService.getAccountRights(vm);
    },

    async prevPage() {
      const vm = this;
      if (vm.currentPage <= 0) {
        return false;
      }
      if (vm.currentPage > 0) {
        vm.currentPage--;
      }
      vm.loading = true;
      await vm.fetch_events();
      vm.loading = false;
    },

    async nextPage() {
      const vm = this;
      if (vm.lastPage <= vm.limit) {
        return false;
      }
      vm.currentPage++;
      vm.loading = true;
      await vm.fetch_events();
      vm.loading = false;
    },

    async syncSuperCheckin() {
      this.superCheckin.loading = true;
      await accountService.syncSuperCheckin(this, this.superCheckin);
      mixpanel.track("web.settings.services.supercheckin.sync");
    },

    openEditAirbnbAccountModal(account) {
      this.airbnbAccount = account;
      this.openModal("#edit-airbnb-account");
    },

    editAirbnbAccount(editAirbnbAccountPwd) {
      this.smallLoading = true;
      const data = {
        randomDeviceId: this.randomDeviceId,
        editAirbnbAccountPwd,
        airbnbAccount: this.airbnbAccount,
      };
      accountService.editAirbnbAccountPwd(this, data);
    },

    async deleteSuperCheckinAccount(id) {
      await accountService.deleteSuperCheckinAccount(this, id);
      await accountService.fetchAccount(this);
    },

    async deleteNetatmoAccount() {
      await accountService.deleteNetatmoAccount(this);
      await accountService.fetchAccount(this);
    },

    selectAllRentals(id = null) {
      if (id == "all") {
        this.newAirbnbRentals.map(
          (rental) => (rental.checked = this.abAccount.allRentalsSelected)
        );
      } else {
        const length = this.newAirbnbRentals.length;
        const selectedRentalsLength = this.newAirbnbRentals.filter(
          (rental) => rental.checked === true
        ).length;
        if (selectedRentalsLength == length) {
          this.abAccount.allRentalsSelected = true;
        } else {
          this.abAccount.allRentalsSelected = false;
        }
      }
      this.$forceUpdate();
    },

    importAirbnbListings() {
      const checkedRentals = this.newAirbnbRentals.filter(
        (rental) => rental.checked === true
      );
      if (checkedRentals.length === 0) {
        this.closeModal(".add-new-airbnb-account");
        this.closeModal("#import-airbnb-rentals");
      } else {
        this.abAccount.loading = true;
        rentalService.importAirbnbListingsToBeds24(
          this,
          checkedRentals,
          this.airbnbAccount,
          false
        );
      }
    },

    skipImport() {
      this.resetAirbnbLogin();

      this.closeModal(".add-new-airbnb-account");
      toastr.success(
        this.$t("account.settings.platforms.airbnb.account_configure_success")
      );
    },

    show_sync_in_process_modal() {
      if (this.users.isSyncInProgress) {
        if (!$(".sync-in-process-modal").hasClass("show")) {
          $(".sync-in-process-modal").addClass("show");
          $("body").addClass("modal-open");
          $("body").append('<div class="modal-backdrop fade show"></div>');
          $(".modal-content").css({ display: "block" });
          $(".navbar").css({ "z-index": "0" });
        }
      }
    },

    openImportNewRentalsModal(account) {
      this.$refs.airbnbImportModal.openImportNewRentalsModal(account);
    },

    openImportAirbnbXmlNewRentalsModal(account) {
      this.listings = [];
      this.currentAibnbAccountId = account.id;
      this.airbnbActiveLoading = true;
      this.currentAirbnbXmId = account.airbnbxml_channel_id;
      this.airbnbAllListing();
      // this.getAllRentals();
    },

    async openServiceModal(name, isSuperCheckin = null) {
      if (isSuperCheckin) {
        this.superCheckin.loading = true;
        this.superCheckin.superCheckinUsername = "";
        this.superCheckin.superCheckinPassword = "";
      } else {
        this.users.setting = { ...store.state.account.setting };
        this.users.setting = { ...store.state.account.setting };
      }
      await accountService.fetchAccount(this);
      this.openModal(name);
    },

    updateWebsiteSettings(field, value) {
      if (!this.users.website_settings) {
        this.users.website_settings = {};
      }

      this.users.website_settings[field] = value;
    },

    airbnbConnectUpdate() {
      this.abAccount.errorMsg = "";
      switch (this.airbnbActiveStep) {
        case 1: // Request connection to airbnb
          airbnb.connect(this);
          break;
        case 2: // Wait for airbnb validation from SH
          const waitForAirbnbValidation = setInterval((_) => {
            airbnb.waitingAirlockVerification(this, waitForAirbnbValidation);
          }, 5000);
          break;
        case 3: // Send MFA request validation
          airbnb.sendMFAVerification(this);
          break;
        case 4: // Send MFA received code
          airbnb.sendMFACode(this);
          break;
        case 5: // Import rentals
          this.smallLoading = true;
          rentalService.getNewAirbnbRentals(this, this.airbnbUserId);
          accountService.getAirbnbAccounts(this);
          break;
      }
    },

    airbnbAllListing() {
      airbnb.getListings(this).then((response) => {
        this.airbnbActiveLoading = false;
        this.showAddNewAccount(3);
        accountService.getAirbnbAccounts(this);
      });
    },

    redirectAirbnbOauth() {
      airbnb.redirectOauth(this);
    },

    airbnbConnectAibnb() {
      this.abAccount.errorMsg = "";
      switch (this.airbnbActiveStep) {
        case 1: // Request connection to airbnb
          if (this.selectedOption === "owner_account") {
            this.airbnbActiveStep = 2;
          } else if (this.email_another_account_airbnb != "") {
            this.airbnbActiveStep = 2;
          }
          break;
        case 2: // Wait for airbnb validation from SH
          if (this.selectedOption === "owner_account") {
            this.disableConnectAirbnbBtn = true;
            airbnb.connectionLink(this).then((response) => {
              this.disableConnectAirbnbBtn = false;
              if (this.redirectlink) {
                window.open(this.redirectlink, "_blank");
              }
            });

            /*
              airbnb.webhook(this).then((response) => {
                console.log(response, 'webhook response');
              });
             */
          } else {
            this.airbnbActiveStep = 3;
          }
          break;
        case 3:
          airbnb.listingCreate(this).then((response) => {
            this.dismissModal();
            this.listings = [];
          });
          break;
      }
    },

    sendMail() {
      this.airbnbActiveLoading = true;
      airbnb.sendEmail(this).then((response) => {
        toastr.success(this.$t("account.settings.platforms.airbnb.email_sent"));
        accountService.getAirbnbAccounts(this);
        this.airbnbActiveLoading = false;
        this.dismissModal();
      });
    },

    prevStep() {
      if (this.airbnbActiveStep != 1) {
        this.airbnbActiveStep = this.airbnbActiveStep - 1;
      }
    },
  },

  async mounted() {
    const hash = window.location.hash;
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    this.code = params.get("code");
    this.state = params.get("state");

    this.$nextTick(() => {
      // $(".selectpicker").selectpicker();
    });

    if (this.code) {
      airbnb.userCreate(this).then((response) => {
        if (this.currentAibnbAccountId != "") {
          accountService.getAirbnbAccounts(this);
          this.airbnbAllListing();
        }
      });
    }

    this.getAllRentals();
    accountService.getAirbnbAccounts(this);

    const vm = this;
    Vue.filter("formatDate", (date) => {
      if (!date) {
        return "N/A";
      }
      return moment(date, "YYYY-MM-DD HH:mm:ss")
        .lang(localStorage.getItem("lang"))
        .format("d/M/YYYY HH:mm:ss");
    });

    vm.loading = true;
    if (vm.$route.params.showAirbnbImport) {
      vm.showAirbnbImport = true;
    }
    if (vm.$route.params.tab) {
      vm.change_tab(vm.$route.params.tab);
    }

    await vm.fetch_account();
    await vm.getStripeAccounts();
    await vm.getTheamMembers();
    // await vm.getAirbnbAccounts();
    await vm.getAccountRights();

    // if (typeof window.Site !== "undefined") {
    //   window.Site.getInstance().initializePlugins();
    // }

    // if (clipboard) {
    //   clipboard.destroy();
    // }

    // clipboard = new Clipboard(".btn8");
    // clipboard.on("success", (e) => {
    //   toastr.success(
    //     vm.$t("account.settings.user_events_section.response_copied")
    //   );
    //   e.clearSelection();
    // });

    // clipboard.on("error", (e) => {
    //   toastr.error(vm.$t("account.settings.user_events_section.error_copy"));
    // });

    // if (vm.showAirbnbImport) {
    //   vm.openModal(".add-new-airbnb-account");
    // }

    // vm.loading = false;
  },
  watch: {
    events(val) {
      const vm = this;
      vm.events = val;
    },

    airbnbOauthUrl(val) {
      console.log(val);
      // if (val) {
      //   window.location.href = val;
      // }
    },

    frictionDataReceived(newData, oldData) {
      if (!oldData && newData) {
        const {
          airlockId,
          phoneNumberId,
          randomDeviceId,
          verificationFrictionType,
        } = this;
        const data = {
          airlockId,
          randomDeviceId,
          verificationFrictionType,
          phoneNumberId,
        };
        // accountService.sendSmsV2(this, data);

        accountService.airlockValidationV2(this, data);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/settings.js